<template>
  <!-- Header -->
  <div class="header">
    <!-- Logo -->
    <div class="header-left active">
      <router-link to="/dashboard/leads-dashboard" class="logo logo-normal">
        <img src="@/assets/img/savor-logo.png" alt="Logo" />
        <img src="@/assets/img/savor-logo.png" class="white-logo" alt="Logo" />
      </router-link>
      <router-link to="/dashboard/leads-dashboard" class="logo-small">
        <img src="@/assets/img/logo-small.svg" alt="Logo" />
      </router-link>
      <a id="toggle_btn" @click="toggleSidebar" href="javascript:void(0);">
        <i class="ti ti-arrow-bar-to-left"></i>
      </a>
    </div>
    <!-- /Logo -->

    <a
      id="mobile_btn"
      class="mobile_btn"
      href="#sidebar"
      @click="toggleSidebar1"
    >
      <span class="bar-icon">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </a>

    <div class="header-user">
      <ul class="nav user-menu">
        <!-- Search -->
        <li class="nav-item nav-search-inputs me-auto">
          <div class="top-nav-search">
            <a href="javascript:void(0);" class="responsive-search">
              <i class="fa fa-search"></i>
            </a>
            <form action="#" class="dropdown">
            
            </form>
          </div>
        </li>
        <!-- /Search -->

        <!-- Nav List -->
        <li class="nav-item nav-list">
          <ul class="nav">
            <li class="dark-mode-list">
              <a
                href="javascript:void(0);"
                id="dark-mode-toggle"
                class="dark-mode-toggle"
                @click="toggleDarkMode"
              >
                <i
                  class="ti ti-sun light-mode"
                  :class="{ active: isLightMode }"
                ></i>
                <i
                  class="ti ti-moon dark-mode"
                  :class="{ active: !isLightMode }"
                ></i>
              </a>
            </li>
          </ul>
        </li>
        <!-- /Nav List -->


        <NotificationModal></NotificationModal>

        <!-- Profile Dropdown -->
        <li class="nav-item dropdown has-arrow main-drop">
          <a
            href="javascript:void(0);"
            class="nav-link userset"
            data-bs-toggle="dropdown"
          >
            <span class="user-info">
              <span class="user-letter">
                <img :src="userProfilePicture" alt="Profile" />
              </span>
              <span class="badge badge-success rounded-pill"></span>
            </span>
          </a>
          <div class="dropdown-menu menu-drop-user">
            <div class="profilename">
              <router-link class="dropdown-item" to="/dashboard">
                <i class="ti ti-layout-2"></i> Dashboard
              </router-link>
              <router-link class="dropdown-item" to="/profile-update">
                <i class="ti ti-user-pin"></i> My Profile
              </router-link>
              <span class="btn dropdown-item" @click="logout">
                <i class="ti ti-lock"></i> Logout
              </span>
            </div>
          </div>
        </li>
        <!-- /Profile Dropdown -->
      </ul>
    </div>

    <!-- Mobile Menu -->
    <div class="dropdown mobile-user-menu">
      <a
        href="javascript:void(0);"
        class="nav-link dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        ><i class="fa fa-ellipsis-v"></i
      ></a>
      <div class="dropdown-menu">
        <router-link class="dropdown-item" to="/dashboard">
          <i class="ti ti-layout-2"></i> Dashboard
        </router-link>
        <router-link class="dropdown-item" to="/profile-update">
          <i class="ti ti-user-pin"></i> My Profile
        </router-link>
        <span class="btn dropdown-item" @click="logout">
          <i class="ti ti-lock"></i> Logout
        </span>
      </div>
    </div>
    <!-- /Mobile Menu -->
  </div>
  <!-- /Header -->

  <side-settings></side-settings>
</template>

<script>
import http from "@/utils/http";
import NotificationModal from "./notification-modal.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    NotificationModal,
  },
  data() {
    return {
      isLightMode: true,
    };
  },
  methods: {
    async logout() {
      try {
        const response = await http.post("/logout");

        this.$toast.success(response.data.message);
        localStorage.removeItem("bearer_token");
        localStorage.removeItem("token_expiration");
        this.$router.push("/");
      } catch (error) {
        console.error("Error during logout:", error);
      }
    },
    toggleSidebar1() {
      const body = document.body;
      body.classList.toggle("slide-nav");
    },
    toggleSidebar() {
      const body = document.body;
      body.classList.toggle("mini-sidebar");
    },
    initializeDarkMode() {
      if (localStorage.getItem("darkMode") === "enabled") {
        this.enableDarkMode();
      }
    },
    enableDarkMode() {
      document.documentElement.setAttribute("data-theme", "dark");
      this.isLightMode = false;
      localStorage.setItem("darkMode", "enabled");
    },
    disableDarkMode() {
      document.documentElement.setAttribute("data-theme", "light");
      this.isLightMode = true;
      localStorage.removeItem("darkMode");
    },
    toggleDarkMode() {
      if (this.isLightMode) {
        this.enableDarkMode();
      } else {
        this.disableDarkMode();
      }
    },
    initMouseoverListener() {
      document.addEventListener("mouseover", this.handleMouseover);
    },
    handleMouseover(e) {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        this.isElementVisible(toggleBtn)
      ) {
        const target = e.target.closest(".sidebar, .header-left");

        if (target) {
          body.classList.add("expand-menu");
          this.slideDownSubmenu();
        } else {
          body.classList.remove("expand-menu");
          this.slideUpSubmenu();
        }

        e.preventDefault();
      }
    },
    isElementVisible(element) {
      return element.offsetWidth > 0 || element.offsetHeight > 0;
    },
    slideDownSubmenu() {
      const subdropPlusUl = document.getElementsByClassName("subdrop");
      for (let i = 0; i < subdropPlusUl.length; i++) {
        const submenu = subdropPlusUl[i].nextElementSibling;
        if (submenu && submenu.tagName.toLowerCase() === "ul") {
          submenu.style.display = "block";
        }
      }
    },
    slideUpSubmenu() {
      const subdropPlusUl = document.getElementsByClassName("subdrop");
      for (let i = 0; i < subdropPlusUl.length; i++) {
        const submenu = subdropPlusUl[i].nextElementSibling;
        if (submenu && submenu.tagName.toLowerCase() === "ul") {
          submenu.style.display = "none";
        }
      }
    },
  },
  mounted() {
    this.initializeDarkMode();
    this.initMouseoverListener();
  },
  computed: {
    ...mapGetters(["userInfo"]),

    userProfilePicture() {
      if (
        !this.userInfo ||
        !this.userInfo.employee ||
        !this.userInfo.employee.profile_picture
      ) {
        return require("@/assets/img/profiles/avatar-14.jpg");
      }
      return this.userInfo.employee.profile_picture;
    },
  },
  beforeUnmount() {
    document.removeEventListener("mouseover", this.handleMouseover);
  },
};
</script>
